import segment from 'util/analytics/segment'
import { SchoolType } from './types'

type Action =
  | 'opened'
  | 'closed'
  | 'completed_login'
  | 'completed_sign_up'
  | 'completed_contact'
  | 'completed_confirmation'

interface ITrackDataForSchool {
  schoolId: number
  sessionId: string
}

interface ITrackDataForExternalSchool {
  externalSchoolId: number
  sessionId: string
}

export type TrackData = ITrackDataForSchool | ITrackDataForExternalSchool

const events = {
  closed: 'Closed',
  completed_confirmation: 'Completed Confirmation',
  completed_contact: 'Completed Contact',
  completed_login: 'Completed Login',
  completed_sign_up: 'Completed Sign Up',
  opened: 'Opened',
}

export function track(action: Action, schoolType: SchoolType, data: TrackData) {
  switch (schoolType) {
    case SchoolType.Internal:
      return segment.track(`Contact School Modal ${events[action]}`, data)
    case SchoolType.External:
      return segment.track(`Request Info Modal ${events[action]}`, data)
  }
}
